import { createSlice } from '@reduxjs/toolkit';
import { ICurrentGuestState } from './types';

const initialState: ICurrentGuestState = {
  guest: null,
  isLoading: false,
};

const createGuestSlice = createSlice({
  name: 'createGuest',
  initialState,
  reducers: {
    setGuest(state, { payload }) {
      state.guest = payload;
    },
    resetGuestState(state) {
      state.guest = null;
    },
    setLoadingStatus(state, { payload }) {
      state.isLoading = payload;
    },
  },
});

export const { setGuest, resetGuestState, setLoadingStatus } =
  createGuestSlice.actions;
export const createGuestReducer = createGuestSlice.reducer;
